import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dActivityLogRepository from "~/repository/UiMeet3d/UiMeet3dActivityLogRepository";
import UiMeet3dActivityLog from "~/models/UiMeet3d/UiMeet3dActivityLog";

class UiMeet3dActivityLogStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dActivityLogs = [];

  /**
   * @property {UiMeet3dActivityLog|null}
   */
  @observable uiMeet3dActivityLog = null;

  /**
   * @property {number|null}
   */
  uiMeet3dActivityLogId = null;

  uiMeet3dActivityLogRepository = null;

  constructor() {
    super();

    this.uiMeet3dActivityLogRepository = new UiMeet3dActivityLogRepository();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    return this.uiMeet3dActivityLogRepository.fetch(params).then(response => {
      this.processEntities(response.data.uiMeet3dActivityLogs);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(uiMeet3dActivityLogs = []) {
    this.uiMeet3dActivityLogs = [];

    uiMeet3dActivityLogs.forEach(uiMeet3dActivityLogArray => {
      const uiMeet3dActivityLog = new UiMeet3dActivityLog(uiMeet3dActivityLogArray);

      this.uiMeet3dActivityLogs.push(uiMeet3dActivityLog);
    });
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Activity Logs.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Activity Logs.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }
}

export default UiMeet3dActivityLogStore;
